module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.25cf49a7.svg";